import React, { Fragment, Suspense } from "react";
import { Helmet } from "react-helmet";
import { metaTag } from "../Library/commomLib";
import Preloader from "../Components/Common/Preloader";
const SendMileageComponent = React.lazy(() => import("../Components/RootComponents/SendMileageComponent"));
const SendMileagePage = () => {
  return (
    <Fragment>
      <Suspense fallback={<Preloader />}>
        <Helmet>
          <title>{metaTag}</title>
          <meta name={metaTag} content={metaTag} />
        </Helmet>
        <SendMileageComponent />
      </Suspense>
    </Fragment>
  );
};

export default SendMileagePage;
